import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  padding: 20px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.common.white};
`;

export const Header = styled.h1`
  color: ${({ theme }) => theme.palette.primary.dark};
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
`;

export const SubText = styled.p`
  color: ${({ theme }) => theme.palette.primary.dark};
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  margin: 0;
`;

export const ContactContainer = styled.div`
  display: flex;
  padding: 50px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  border-radius: 8px;
  background: ${({ theme }) => theme.tint.primary.subtle};
  h1 {
    color: ${({ theme }) => theme.palette.primary.dark};
    font-family: Roboto;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin: 0;
  }

  p {
    color: ${({ theme }) => theme.palette.primary.dark};
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 30px;
    margin: 0;
  }
`;
